import { useState, useEffect } from 'react'
import axios from 'axios'
import { LoraType } from '@shared-types'

export function useLoras(maxSelect: number = 5) {
  const [loras, setLoras] = useState<LoraType[]>([])
  const [selectedLoras, setSelectedLoras] = useState<LoraType[]>([])
  const [gallery, setGallery] = useState<string[]>([])
  const [displayImage, setDisplayImage] = useState<string>('')

  useEffect(() => {
    axios
      .get('https://civitai.com/api/v1/models?type=LORA&limit=50')
      .then(r => {
        const items = r.data.items || []
        const all: LoraType[] = items.map((item: any) => {
          const version = (item.modelVersions && item.modelVersions[0]) || {}
          return {
            id: item.id,
            name: item.name,
            description: item.description || '',
            model_name: version.baseModel || '',
            images: version.images?.map((i: any) => i.url) || [],
            lora_profile: version.name || ''
          } as LoraType
        })
        setLoras(all)
      })
      .catch(console.error)
  }, [])

  useEffect(() => {
    if (!selectedLoras.length) {
      setGallery([])
      setDisplayImage('')
      return
    }
    const allImages = selectedLoras.flatMap(l => l.images || [])
    setGallery(allImages)

    if (allImages.length) {
      setDisplayImage(allImages[Math.floor(Math.random() * allImages.length)])
    } else {
      setDisplayImage('')
    }
  }, [selectedLoras])

  const toggleLora = (lora: LoraType) => {
    const exists = selectedLoras.find(l => l.id === lora.id)
    if (exists) {
      setSelectedLoras(selectedLoras.filter(l => l.id !== lora.id))
    } else if (selectedLoras.length < maxSelect) {
      setSelectedLoras([...selectedLoras, lora])
    }
  }

  return { loras, selectedLoras, setSelectedLoras, toggleLora, gallery, displayImage }
}
